import {Logger} from 'neo-common';
import {GameDataLoaded, IPlatforms} from './IPlatforms';
import {Platforms} from './Platforms';

export class PlatformRelax implements IPlatforms {

    public create(): void {
        Platforms.canPlay = true;

        if (DEBUG) {
            this.log('create');
        }

        this.createPlugin();
    }

    public loadProgress(progress: number): void {}

    public gameReady(): void {
        if (DEBUG) {
            this.log('gameReady');
        }

        if ((window['RgPostMessageAPI'] as any) != null) {
            (window['RgPostMessageAPI'] as any).reportGameReady();
        }
    }

    public gameFailed(): void {}

    public gameClosing(): void {}

    public gameReloading(): void {}

    public gameChange(gameCode: string): void {}

    public error(code: string, message: string): void {}

    public clientError(id: string, message: string): void {}

    public roundInit(): void {}

    public roundStarted(): void {
        if (DEBUG) {
            this.log('roundStarted');
        }

        if ((window['RgPostMessageAPI'] as any) != null) {
            (window['RgPostMessageAPI'] as any).gameRoundStarted();
        }
    }

    public spinStarted(): void {}

    public spinReceived(): void {}

    public spinEnded(): void {}

    public roundEnded(): void {
        if (DEBUG) {
            this.log('roundEnded');
        }

        if ((window['RgPostMessageAPI'] as any) != null) {
            (window['RgPostMessageAPI'] as any).gameRoundEnded();
        }
    }

    public featureStarted(): void {}

    public featureInit(): void {}

    public featureFinished(): void {}

    public autoplayStarted(): void {}

    public autoplayFinished(): void {}

    public gotoCasier(): void {}

    public gotoHistory(): void {}

    public gotoHelp(): void {}

    public gotoPaytable(): void {}

    public balanceUpdated(): void {}

    public sendPluginMessage(message: string): void {}

    public setVolume(level: number): void {}

    public quickSpinEnabled(enabled: boolean): void {}

    public bet(value: number): void {}

    public win(value: number): void {}

    public userAction(action: string, data: Object): void {
        if (DEBUG) {
            this.log('userAction');
        }

        if (action === 'exit') {
            if (data['url'] != null) {
                if ((window['RgPostMessageAPI'] as any) != null) {
                    (window['RgPostMessageAPI'] as any).userAction(data['url']);
                }
            }
        }
    }

    public gameDataLoaded(args: GameDataLoaded): void {}

    public dialogOpened(type: string, isOpen: boolean): void {}

    public fullscreen(enabled: boolean): void {}

    private createPlugin(): void {
        if (DEBUG) {
            this.log('createPlugin');
        }

        if (Platforms.pluginUrl != null) {
            let script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('src', Platforms.pluginUrl);
            script.onload = this.loadPlugin.bind(this);
            document.head.appendChild(script);
        }
    }

    private loadPlugin(): void {
        if (DEBUG) {
            this.log('loadPlugin');
        }

        window.addEventListener('rg_pause', this.pause.bind(this));
        window.addEventListener('rg_resume', this.resume.bind(this));
        window.addEventListener('rg_updateBalance', this.updateBalance.bind(this));

        if ((window['RgPostMessageAPI'] as any) != null) {
            (window['RgPostMessageAPI'] as any).init(true);
        }
        Platforms.canPlay = true;
    }

    private pause(e: any): void {
        if (DEBUG) {
            this.log('pause');
        }

        if (e.data && e.data.autoPlayOnly) {
            Platforms.stopAutoplay();
        } else {
            Platforms.gamePlayStop();
            if ((window['RgPostMessageAPI'] as any) != null) {
                (window['RgPostMessageAPI'] as any).reportPaused();
            }
        }
    }

    private resume(): void {
        if (DEBUG) {
            this.log('resume');
        }

        Platforms.gamePlayResume();
    }

    private updateBalance(): void {
        if (DEBUG) {
            this.log('updateBalance');
        }

        Platforms.refreshBalance();
    }

    protected log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup('Relax', 'Relax ' + s);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Platforms/PlatformRelax.ts
 **/